module.exports = __webpack_public_path__ + "static/media/Document-Checklist.0801a743.svg";